import { connect } from 'react-redux';
import { RootState } from '../reducers/root';
import { SingleStainsPage } from '../components/PerformancePrediction/SingleStainsPage';

const mapStateToProps = (state: RootState) => ({
  benchmark: state.UserInputState.benchmark,
  benchmarkType: state.UserInputState.benchmarkType,
  StainGroupNames: state.UserInputState.stainGroupNames,
  region: state.UserInputState.region,
  StainGroups: state.FormulationSpace.StainGroups,
  ModelPredictionData: state.FormulationSpace.ModelPredictionData,
  BenchmarkData: state.FormulationSpace.BenchmarkData,
});

export default connect(mapStateToProps)(SingleStainsPage);
